var map = {
	"./CRSSelector": 32027,
	"./CRSSelector.jsx": 32027,
	"./MousePosition": 83366,
	"./MousePosition.jsx": 83366,
	"./MousePositionLabelDD": 69315,
	"./MousePositionLabelDD.jsx": 69315,
	"./MousePositionLabelDM": 49073,
	"./MousePositionLabelDM.jsx": 49073,
	"./MousePositionLabelDMS": 14300,
	"./MousePositionLabelDMS.jsx": 14300,
	"./MousePositionLabelDMSNW": 48784,
	"./MousePositionLabelDMSNW.jsx": 48784,
	"./MousePositionLabelYX": 45706,
	"./MousePositionLabelYX.jsx": 45706,
	"./__tests__/CRSSelector-test": 87983,
	"./__tests__/CRSSelector-test.js": 87983,
	"./__tests__/MousePosition-test": 85145,
	"./__tests__/MousePosition-test.js": 85145,
	"./__tests__/MousePositionLabelDM-test": 98728,
	"./__tests__/MousePositionLabelDM-test.js": 98728,
	"./__tests__/MousePositionLabelDMS-test": 84957,
	"./__tests__/MousePositionLabelDMS-test.js": 84957,
	"./__tests__/MousePositionLabelDMSNW-test": 33196,
	"./__tests__/MousePositionLabelDMSNW-test.js": 33196,
	"./avitech/MousePositionLabelDMS": 28506,
	"./avitech/MousePositionLabelDMS.jsx": 28506,
	"./avitech/MousePositionLabelPixel": 66759,
	"./avitech/MousePositionLabelPixel.jsx": 66759,
	"./mousePosition.css": 99641
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5615;